import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/userAccessToken/findAll", {params: params});
  },
  findByUser(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/userAccessToken/findByUser", {params: params});
  },
  count(params) {
    return httpService.get("/userAccessToken/count", {params: params});
  },
  findById(id) {
    return httpService.get(`/userAccessToken/${id}`)
  },
  save(form) {
    return httpService.post("/userAccessToken", form);
  },
  update(id, form) {
    return httpService.put(`/userAccessToken/${id}`, form)
  },
  delete(id) {
    return httpService.delete(`/userAccessToken/${id}`)
  },
  active(id) {
    return httpService.post(`/userAccessToken/active/${id}`)
  },
  deactive(id) {
    return httpService.post(`/userAccessToken/deactive/${id}`)
  },
  cleanAccessToken(id) {
    return httpService.post(`/userAccessToken/cleanAccessToken/${id}`);
  },

};



// WEBPACK FOOTER //
// ./src/services/userAccessTokenService.js